<div class="preview_wrapper">
  <p class="title">Add Change Order
    <span class="green_circle_tick">
            <img src="../../../../assets/img/white_tick.svg" alt="">
        </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Job</p>
        <p class="value" >{{changeOrder?.jobName}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Change Order Type</p>
        <p class="value">{{changeOrder?.orderType?.name}}</p>
      </div>
    </div>



  </div>
</div>

<div class="preview_wrapper">
  <p class="title">Drawing
    <span class="green_circle_tick">
            <img src="../../../../assets/img/white_tick.svg" alt="">
        </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Drawing Date</p>
        <p class="value">{{drawing?.date | date}}</p>
      </div>
    </div>
    <div class="col-md-5">
      <div class="wrap">
        <p class="heading">Drawing Type</p>
        <p class="value">{{drawing?.type?.name}}</p>
      </div>
    </div>
    <div class="col-md-1">
      <div class="wrap">
        <p class="heading">No.#</p>
        <p class="value">{{drawing?.number}}</p>
      </div>
    </div>


  </div>
</div>

